import React, { Component } from 'react';

import NavBar from '../components/navbar';
import MatchCard from '../components/matchCard';
import SideBar from '../components/sidebar1'

class Match extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    handleHistory = () => {
        const history = this.props.history
        history.push({
            pathname: "scope",
            state: {
                res: history.location.state.res ,
                description: history.location.state.description
            }
        })
    }

    render() {
        // console.log(this.props.history.location.state.res.talents[1]);

        return (
            <div>
            <NavBar type="main"/>
            <div className="container">
            <div className="row justify-content-center" >
                <div
                    className="col-lg-4 col-md-4 col-sm-12">
                    <SideBar stage={1} back={this.handleHistory}/>
                </div>
                <div className="col-lg-8 col-sm-12 col-md-8">
                    <div
                        className="row justify-content-center"
                        style={{ display: "grid", placeItems: "center" }}>
                        <div className="col-12 mt-5">
                            <h1 style={{fontFamily: 'Nunito', color: "#414042"}}>
                                <strong>Top Matches To Build Your Team</strong>
                            </h1>
                            <h6 style={{fontFamily: 'Nunito', fontSize: "18px", color: "#414042"}}>
                                These are the top matches that perfectly match your requirements
                            </h6>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3 mb-5">
                        {this.props.history.location.state.res.talents.map((talent) => 
                        <div className="col-lg-4 col-md-6 col-6 mt-5">
                            <MatchCard cv={talent}/>
                        </div>
                        )}
                    </div>
                </div>
            </div>
            </div>
        </div>
        );
    }
}
 
export default Match;
